import React, { Component } from 'react';

class Finale extends Component {
  render() {
    return (
      <div className='text-white finale'>
        <h1 className='bold' style={{fontSize: '3rem'}}>Key Takeaways</h1>
        <ol className='plm f1 slds-list_ordered'>
          <li className='ptl'>Add alternative text for images.</li>
          <li className='ptl'>Include captions or transcripts for videos.</li>
          <li className='ptl'>Use more than color to convey meaning.</li>
          <li className='ptl'>Allow interaction with any input device.</li>
        </ol>
      </div>
    );
  }
}

export default Finale;



// WEBPACK FOOTER //
// ./src/finale.js